import { render, staticRenderFns } from "./BookingDetailDocuments.vue?vue&type=template&id=b2ad8578&"
import script from "./BookingDetailDocuments.vue?vue&type=script&lang=js&"
export * from "./BookingDetailDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports